export let ResponseName = /*#__PURE__*/function (ResponseName) {
  ResponseName["RetrieveBitcoinAccountResponse"] = "RetrieveBitcoinAccountResponse";
  return ResponseName;
}({});
export function handleResponseError(context, responseName, response, error) {
  if (error) {
    context.sentry.captureException(`Error in ${responseName}: ${error.message}`);
    return true;
  } else if (response?.error && response.error.length > 0) {
    const responseError = response.error[0];
    const errorMessage = responseError?.detail ? `Error in ${responseName}: ${responseError.detail}` : `Error in ${responseName}`;
    context.sentry.captureException(errorMessage);
    return true;
  } else if (response?.errors && response.errors.length > 0) {
    const responseError = response.errors[0];
    const errorMessage = responseError?.detail ? `Error in ${responseName}: ${responseError.detail}` : `Error in ${responseName}`;
    context.sentry.captureException(errorMessage);
    return true;
  }
  return false;
}